import { render, staticRenderFns } from "./ComparePage.vue?vue&type=template&id=3bee0ba5"
import script from "./ComparePage.vue?vue&type=script&lang=js"
export * from "./ComparePage.vue?vue&type=script&lang=js"
import style0 from "./ComparePage.vue?vue&type=style&index=0&id=3bee0ba5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports